import React, { useEffect } from 'react';
import { LuTriangleAlert  } from 'react-icons/lu';
import '../styles/ConfirmModal.css';

const ConfirmModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  danger = false,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  showCancelButton = true,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="confirm-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <div className={`confirm-icon${danger ? ' danger' : ''}`}>
          <LuTriangleAlert  />
        </div>
        <h3 className="confirm-title" id="confirm-title">{title}</h3>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          {showCancelButton && (
            <button className="confirm-btn-cancel" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button
            className={`confirm-btn-confirm${danger ? ' danger' : ''}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
